// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfh_a bhe_vc bhe_rm bhe_wf"};